import {
    FCL_IMPORT_ARRIVAL_NOTICE_REPORT_LIST,
    FCL_IMPORT_ARRIVAL_NOTICE_REPORT_SUMMARY,
    FCL_IMPORT_ACTIVE_SHIPMENT_REPORT_LIST,
    FCL_IMPORT_ACTIVE_SHIPMENT_REPORT_SUMMARY,
    FCL_IMPORT_BOOKING_REPORT_LIST,
    FCL_IMPORT_BOOKING_REPORT_SECTIONS,
    FCL_IMPORT_BOOKING_REPORT_SUMMARY,
    FCL_IMPORT_CONTAINER_DEMURRAGE_REPORT_LIST,
    FCL_IMPORT_CONTAINER_DEMURRAGE_REPORT_SUMMARY,
    FCL_IMPORT_CONTAINER_TRACKING_REPORT_LIST,
    FCL_IMPORT_CONTAINER_TRACKING_REPORT_SUMMARY,
    FCL_IMPORT_ETA_STATUS_REPORT_LIST,
    FCL_IMPORT_ETA_STATUS_REPORT_SUMMARY,
    FCL_IMPORT_STATUS_AUDIT_REPORT_LIST,
    FCL_IMPORT_STATUS_AUDIT_REPORT_SUMMARY,
    FCL_IMPORT_TRUCKING_REPORT_LIST,
    FCL_IMPORT_TRUCKING_REPORT_SUMMARY,
    FCL_IMPORT_FILE_CANCELLATION_REPORT_LIST,
    FCL_IMPORT_FILE_CANCELLATION_REPORT_SUMMARY,
    FCL_IMPORT_ARRIVAL_NOTICE_PRE_ALERT_REPORT_LIST,
    FCL_IMPORT_ARRIVAL_NOTICE_PRE_ALERT_REPORT_SUMMARY,
} from "./constant";
import { APICall } from "@/config/NetworkUtility";
import {
    buildFclImportArrivalNoticeParams,
    buildFclImportActiveShipmentParams,
    buildFclImportBookingParams,
    buildFclImportContainerDemurrageParams,
    buildFclImportContainerTrackingParams,
    buildFclImportEtaStatusParams,
    buildFclImportStatusAuditParams,
    buildFclImportTruckingParams,
    buildFclImportFileCancellationParams,
    buildFclImportArrivalNoticePreAlertParams,
    buildReportQueryString,
    isFclReportApiSuccess,
} from "@/utility/fclReportHelpers";
import { parseFclConfiguredReportResponse } from "@/utility/fclReportParsers";

const createImportReportAction = (
    endpoint,
    reportKey,
    listType,
    summaryType,
    buildParams,
    sectionType = null
) => {
    return (payload) => {
        return (dispatch) => {
            const queryString = buildReportQueryString(buildParams(payload));
            const url = queryString
                ? `v1/FCLImportReports/${endpoint}?${queryString}`
                : `v1/FCLImportReports/${endpoint}`;

            return APICall("get", null, url).then(
                (result) => {
                    if (!isFclReportApiSuccess(result)) {
                        return Promise.reject(result);
                    }

                    const { primaryList, summary, sections } =
                        parseFclConfiguredReportResponse(reportKey, result);

                    dispatch({ type: listType, payload: primaryList });
                    dispatch({ type: summaryType, payload: summary });
                    if (sectionType) {
                        dispatch({ type: sectionType, payload: sections });
                    }
                    return primaryList;
                },
                (error) => Promise.reject(error)
            );
        };
    };
};

export const getFclImportBookingReport = createImportReportAction(
    "GetBookingReport",
    "importBooking",
    FCL_IMPORT_BOOKING_REPORT_LIST,
    FCL_IMPORT_BOOKING_REPORT_SUMMARY,
    buildFclImportBookingParams,
    FCL_IMPORT_BOOKING_REPORT_SECTIONS
);

export const getFclImportActiveShipmentReport = createImportReportAction(
    "GetActiveShipmentReport",
    "importActiveShipment",
    FCL_IMPORT_ACTIVE_SHIPMENT_REPORT_LIST,
    FCL_IMPORT_ACTIVE_SHIPMENT_REPORT_SUMMARY,
    buildFclImportActiveShipmentParams
);

export const getFclImportContainerDemurrageReport = createImportReportAction(
    "GetContainerDemurrageReport",
    "importDemurrage",
    FCL_IMPORT_CONTAINER_DEMURRAGE_REPORT_LIST,
    FCL_IMPORT_CONTAINER_DEMURRAGE_REPORT_SUMMARY,
    buildFclImportContainerDemurrageParams
);

export const getFclImportTruckingReport = createImportReportAction(
    "GetTruckingReport",
    "importTrucking",
    FCL_IMPORT_TRUCKING_REPORT_LIST,
    FCL_IMPORT_TRUCKING_REPORT_SUMMARY,
    buildFclImportTruckingParams
);

export const getFclImportStatusAuditReport = createImportReportAction(
    "GetStatusAuditReport",
    "importStatusAudit",
    FCL_IMPORT_STATUS_AUDIT_REPORT_LIST,
    FCL_IMPORT_STATUS_AUDIT_REPORT_SUMMARY,
    buildFclImportStatusAuditParams
);

export const getFclImportContainerTrackingReport = createImportReportAction(
    "GetContainerTrackingReport",
    "importContainerTracking",
    FCL_IMPORT_CONTAINER_TRACKING_REPORT_LIST,
    FCL_IMPORT_CONTAINER_TRACKING_REPORT_SUMMARY,
    buildFclImportContainerTrackingParams
);

export const getFclImportArrivalNoticeReport = createImportReportAction(
    "GetArrivalNoticeReport",
    "importArrivalNotice",
    FCL_IMPORT_ARRIVAL_NOTICE_REPORT_LIST,
    FCL_IMPORT_ARRIVAL_NOTICE_REPORT_SUMMARY,
    buildFclImportArrivalNoticeParams
);

export const getFclImportEtaStatusReport = createImportReportAction(
    "GetETAStatusReport",
    "importEtaStatus",
    FCL_IMPORT_ETA_STATUS_REPORT_LIST,
    FCL_IMPORT_ETA_STATUS_REPORT_SUMMARY,
    buildFclImportEtaStatusParams
);

export const getFclImportFileCancellationReport = createImportReportAction(
    "GetFileCancellationReport",
    "importFileCancellationReport",
    FCL_IMPORT_FILE_CANCELLATION_REPORT_LIST,
    FCL_IMPORT_FILE_CANCELLATION_REPORT_SUMMARY,
    buildFclImportFileCancellationParams
);

export const getFclImportArrivalNoticePreAlertReport = createImportReportAction(
    "GetFCLImpArrivalNoticePreAlertReport",
    "importArrivalNoticePreAlertReport",
    FCL_IMPORT_ARRIVAL_NOTICE_PRE_ALERT_REPORT_LIST,
    FCL_IMPORT_ARRIVAL_NOTICE_PRE_ALERT_REPORT_SUMMARY,
    buildFclImportArrivalNoticePreAlertParams
);
